import React, { useEffect, useState } from "react";
import "./splitWidget.css";
import SaveWidgetButton from "../../button/saveWidgetButton/saveWidgetButton";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import RemoveWidgetButton from "../../button/removeWidgetButton/removeWidgetButton";
import CloseWidgetButton from "../../button/closeWidgetButton/closeWidgetButton";
import SplitWidget from "./splitWidget";

function EditSplitWidget() {
  const currentEvent = useSelector((state) => state.eventReducer.currentEvent);
  const editWidgetContent = useSelector((state) => state.dashboardReducer.editWidgetContent);
  const [widgetId, setWidgetId] = useState(uuidv4());
  const [question, setQuestion] = useState("");
  const [answers, setAnswers] = useState([
    {
      poll_id: uuidv4(),
      dashboard_id: "",
      question: "",
      votes: 0,
    },
  ]);
  const [size, setSize] = useState("large");

  useEffect(() => {
    if (editWidgetContent.type === "split") {
      console.log(editWidgetContent);
      setWidgetId(editWidgetContent.id);
      setQuestion(editWidgetContent.title);
      setAnswers(editWidgetContent.answers);
      setSize(editWidgetContent.size);
    }
  }, [editWidgetContent]);

  return (
    <div
      className="editWidgetModal"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="editWidgetContent">
        <div className="editWidgetTitleRow">
          <div className="editWidgetTitle">Add your split widget</div>
          <CloseWidgetButton />
        </div>
        <div className="editWidgetDesc">Add your costs and see them divided equally amongst attendees.</div>
        <div className="sizeSelector">
          <div className={"sizeSample sizeSampleLarge"}>
            <SplitWidget
              live={false}
              data={{
                id: widgetId,
                type: "split",
                title: question,
                event_id: currentEvent.event_id,
                answers: answers,
                size: size,
                index: editWidgetContent?.index ?? 0,
              }}
            />
          </div>
        </div>
        <div className="saveAction">
          {editWidgetContent?.id ? <RemoveWidgetButton widget={{ dashboard_id: widgetId, event_id: currentEvent.event_id }} /> : null}
          <SaveWidgetButton
            saveContent={{
              id: widgetId,
              type: "split",
              title: "",
              event_id: currentEvent.event_id,
              answers: [],
              size: size,
              index: editWidgetContent?.index ?? 0,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default EditSplitWidget;
